<template>
  <div>
    <ion-page>
      <ion-header class="header-container">
        <ion-toolbar class="header-toolbar">
          <ion-buttons slot="start">
            <ion-back-button
              default-href="/home"
              color="light"
              text=""
            ></ion-back-button>
          </ion-buttons>
          <ion-title class="page-title">Add Card</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <div class="ac-div">
          <ion-label class="label-ac">Card number</ion-label>
          <ion-input
            class="input-ac"
            placeholder="0000 0000 0000 0000"
            type="text"
          />
          <ion-label class="label-ac">Name </ion-label>
          <ion-input class="input-ac" placeholder="Name on card" type="text" />
          <ion-row>
            <ion-col size="6">
              <ion-label class="label-ac">Expired day</ion-label>
              <ion-input class="input-ac" placeholder="12/25" type="text" />
            </ion-col>
            <ion-col size="6">
              <ion-label class="label-ac">CVV</ion-label>
              <ion-input class="input-ac" placeholder="1234" type="text" />
            </ion-col>
          </ion-row>
          <ion-button
            expand="block"
            color="primary"
            class="ac-btn"
            router-link="/payment-management"
          >
            Confirm
          </ion-button>
        </div>
      </ion-content>
      <TheFooter name="TheFooter" />
    </ion-page>
  </div>
</template>
<style scoped>
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.ac-div {
  padding: 5%;
}
.label-ac {
  font-family: "Gilroy-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
}
.input-ac {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #828282;
  border-bottom: #ebebeb 2px solid;
  margin-bottom: 5%;
}
ion-button {
  --background: #ffffff;
  --background-hover: #dce8ff;
  --background-activated: #dce8ff;
  --background-focused: #dce8ff;
  --color: #1b1b1b;
  --border-radius: 4px;
  --border-color: #f3f3f3;
  --border-style: solid;
  --border-width: 1px;
  --ripple-color: #dce8ff;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 20px;
  height: 52px;
  text-transform: none;
}
ion-button:active {
  --color: #f87e63;
}
.ac-btn {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}
</style>
<script>
import { defineComponent } from "vue";
import {
  IonContent,
  IonIcon,
  IonPage,
  IonRow,
  IonCol,
  IonLabel,
  IonInput,
  IonButton,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
} from "@ionic/vue";
import TheFooter from "@/components/TheFooter.vue";

export default defineComponent({
  name: "AddCardPage",
  components: {
    IonContent,
    IonIcon,
    IonPage,
    IonRow,
    IonCol,
    IonLabel,
    IonInput,
    IonButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonBackButton,
    TheFooter,
  },
});
</script>
